import React from 'react'
import Api from './Api'
// import {BrowserRouter as Router} from'react-router-dom'
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'

function App() {
  return (
    <div className="App">
        <Api/>
    </div>
  );
}

export default App;
